import axios from 'axios';

export default class VehicleService {
  
  static async updateVehicleDetails(token, data){
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.post(`${url}/api/v1/pri/update-vehicle`, 
        data,
        {
          headers: {Authorization: `Bearer ${token}`},
        }
      )
      return response;
    } catch (error) {
      console.log(error)
    }
  }

  static async getVehicle(token, rego){
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(`${url}/api/v1/pri/web/get-vehicle?rego=${rego}`, 
        {
          headers: {Authorization: `Bearer ${token}`},
        });
        return response
    } catch (error) {
      
      console.log(error)
    }
  }

  static async getAllVehicles(token) {
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(
        `${url}/api/v1/pri/web/get-vehicles`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  static async getVehicleCategories(token) {
    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(

        `${url}/api/v1/pri/web/get-vehicle-categories`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  static async getVehicleTypesByCategory(token, category){

    try {
      const url = process.env.REACT_APP_BACKEND_URL;
      const response = await axios.get(`${url}/api/v1/pri/web/get-vehicle-types?category=${category}`, {
        headers: {Authorization: `Bearer ${token}`}
      });
      return response;
    } catch (error) {
      console.log(error);
    }
  }
}
